<video #videoPlayer class="video-js" controls config playsinline preload="none"></video>